<template>
  <div
    v-if="points"
    class="leaderboard-table__progress"
    :style="{
      minWidth: caclWidthPersents(points, divider) + '%',
      backgroundColor: randomColor()
    }"
  >
    {{ Math.round(points.replace(",", "")) }}
  </div>
  <div
    v-else
    class="leaderboard-table__cell leaderboard-table__progress"
    style="width: 0; background-color: transparent; color: inherit;"
  >
    0
  </div>
</template>

<script>
export default {
  name: "LeaderBoardProgressbar",
  props: ["points", "divider"],
  data() {
    return {
      progressColors: [
        "#FF5252",
        "#FF4081",
        "#FF4081",
        "#7C4DFF",
        "#448AFF",
        "#03A9F4",
        "#00BCD4",
        "#009688",
        "#4CAF50",
        "#8BC34A",
        "#FFC107",
        "#FF9800",
        "#FF5722",
        "#795548",
        "#607D8B"
      ]
    };
  },
  computed: {},
  methods: {
    caclWidthPersents: function(p, d) {
      return parseFloat(p.replace(/[.,]/g, "")) / d;
    },
    randomColor: function() {
      function randomInteger(min, max) {
        var rand = min - 0.5 + Math.random() * (max - min + 1);
        rand = Math.round(rand);
        return rand;
      }
      let random = randomInteger(0, this.progressColors.length - 1);
      return this.progressColors[random];
    }
  }
};
</script>

<style scoped>
.leaderboard-table__progress {
  display: inline-block;
  /* min-width: 125px; */
  height: 25px;
  line-height: 26px;
  border-radius: 15px;
  padding: 0 15px;
  color: #fff;
  font-size: 12px;
  font-weight: bold;
  opacity: 0.74;
}
</style>
